import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import FileUpload from '../../components/FileUpload/FileUpload';
import SelectFileDropdown from '../../components/SelectFileDropdown/SelectFileDropdown';
import { useAuth } from '../../context/AuthContext';
import { post, get } from '../../services/httpService';
import './UploadFiles.css';
import { PdfDocumentTypeEnum, ProcessFileStatus } from "../../enums/enumStore"
import { toast } from 'react-toastify';
import messages from '../../utils/messages';
import { Card, Col, Dropdown, FormControl, Row } from 'react-bootstrap';
import { XCircleFill } from 'react-bootstrap-icons';
import customLogger from "../../utils/customLogger.js";
import { v4 as uuidv4 } from "uuid";
import DataTable from '../../components/DataTable/DataTable.js';
const UploadFiles = ({ onPrepareData, setAdditionalInfo, additionalParamMap, setAdditionalParamMap, setFileStatusData }) => {
  const [show, setShow] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  // Set default documentType to id
  const defaultDoc = Object.values(PdfDocumentTypeEnum)[0];
  const [defaultDocId, defaultDocLabel] = defaultDoc.split('|');
  const [documentType, setDocumentType] = useState(defaultDocId);

  const [generateSmartNames, setGenerateSmartNames] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPending, setIsPending] = useState(false);

  const [error, setError] = useState(null);
  const [patientList, setPatientList] = useState([]);
  const [loadingPatients, setLoadingPatients] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [containerFiles, setContainerFiles] = useState([]);
  const [loadingContainerFiles, setLoadingContainerFiles] = useState(false);
  const [selectedContainerFiles, setSelectedContainerFiles] = useState([]);
  const [containerFilesFetched, setContainerFilesFetched] = useState(false);
  const pollTimerRef = useRef(null);
  const startTimeRef = useRef(null);
  const [uniqueId, setUniqueId] = useState(uuidv4());
  const [spinner, setSpinner] = useState(true);
  // const isMobile = window.innerWidth <= 575;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);
  const location = useLocation();
  const preselectedPatientId = location.state?.patientId;
  const preselectedFilenames = location.state?.filenames;
  const patientsFetched = useRef(false);
  const effectRan = useRef(false);
  const autoSelectDone = useRef(false);
  const autoSelectFilesDone = useRef(false);

  useEffect(() => {

    const handleResize = () => setIsMobile(window.innerWidth <= 575);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const {
    REACT_APP_ENV
  } = process.env;

  const handleFileSelect = (newFiles) => {
    setSelectedFiles(prevFiles => [...prevFiles, ...newFiles]);
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
  };
  const patients = false;
  const patientsList = [
    {
      patientId: 1,
      firstName: "John",
      lastName: "doe"
    },
    {
      patientId: 1,
      firstName: "Fin",
      lastName: "allen"
    },
    {
      patientId: 1,
      firstName: "Donald",
      lastName: "loo"
    },
  ]
 useEffect(() => {
    // let patientsFetched = false;

    const fetchPatientList = async () => {
      // if (patientsFetched) return; // Skip if patients are fetched
      // if (patients) {
      // patientsFetched = true;
        if (patientsFetched.current) return;  
    patientsFetched.current = true;
      setLoadingPatients(true);

      try {
         customLogger.log("zerobalance-dataprep -> UploadFiles -> useEffect -> Request from react to n8n",
          JSON.stringify({ 'companyId': additionalParamMap.companyId}))
        const response = await fetch(`${API_BASE_URL}/patients?env=${encodeURIComponent(REACT_APP_ENV)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('auth_token')
          },
          body: JSON.stringify({ 'companyId': additionalParamMap.companyId, 'userName': additionalParamMap.userName })
        });

        if (!response.ok) {
          const errorResponse = await response.json();
           customLogger.log("zerobalance-dataprep -> UploadFiles -> useEffect -> Error from n8n to react", errorResponse)
          // console for req 
          if (response.status === 401) {
            // toast.error(messages.errors.SESSION_EXPIRED);
            logout();
            setTimeout(() => {
              navigate('/unauthorized', { state: { authFailed: true } });
            }, 0);
          } else {
            let errorMsg = errorResponse.Description || messages.errors.UNABLE_TO_FETCH_CLIENTS;
            throw new Error(errorMsg);
          }
        }

        const responseData = await response.json();
        customLogger.log("zerobalance-dataprep -> UploadFiles -> useEffect -> Response from n8n to react", responseData)
        const patients = responseData;

        const sortedPatients = [...patients].sort((a, b) => {
          // Compare fisrt names
          const firstNameCompare = a.firstName.localeCompare(b.firstName);
          if (firstNameCompare !== 0) return firstNameCompare;

          // If first names are equal, compare last names
          return a.lastName.localeCompare(b.lastName);
        });

        setPatientList(sortedPatients);
      } catch (error) {
        //console.error('Failed to fetch patients:', error);
         customLogger.log("zerobalance-dataprep -> UploadFiles -> useEffect -> Error in react", error)
        setError(error.message || messages.errors.UNABLE_TO_FETCH_CLIENTS);
      } finally {
        setLoadingPatients(false);
      }
      // } else {
      //   setPatientList(patientsList)
      // }
    };

    fetchPatientList();
    // setUniqueId(uuidv4());

    // Clear polling when component unmounts
    return () => {
      if (pollTimerRef.current) {
        clearTimeout(pollTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (location.state?.from !== "preview") {
      setFileStatusData({
  status: '',
  data: [],
  firstName: '',
  lastName:'',
  patientId: '',
  documentType: '',
  fileName:'',
})
    if (!effectRan.current) {
      getFileStatus();
      effectRan.current = true;
    }
    }
  }, [location.state]);

  useEffect(() => {
    if (autoSelectDone.current) return;
    if (!preselectedPatientId) return;
    if (patientList.length === 0 || loadingPatients) return;
    const patient = patientList.find(p => p.patientId.toString() === preselectedPatientId.toString());
    if (patient) {
      autoSelectDone.current = true;
      setAdditionalParamMap({ ...additionalParamMap, isPreselected: true, patient });
      setSelectedPatient(patient);
      setSelectedContainerFiles([]);
      setContainerFiles([]);
      fetchContainerFiles(patient.patientId);
    }
  }, [patientList, loadingPatients, preselectedPatientId]);

  useEffect(() => {
    if (autoSelectFilesDone.current) return;
    if (!autoSelectDone.current) return;
    if (!preselectedFilenames) return;
    if (!containerFilesFetched) return;
    if (containerFiles.length === 0) return;
    autoSelectFilesDone.current = true;
    const filenameList = decodeURIComponent(preselectedFilenames).split(',').map(f => f.trim()).filter(Boolean);
    const matched = containerFiles.filter(f => filenameList.includes(f.id)).slice(0, 20);
    if (matched.length > 0) {
      setSelectedContainerFiles(matched);
    }
  }, [containerFiles, containerFilesFetched, preselectedFilenames]);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError('');
      }, 30000);

      return () => clearTimeout(timer);
    }
  }, [error]);

  const filteredPatients = patientList?.filter((patient) =>
    `${patient.firstName} ${patient.lastName}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handlePatientSelect = (selectedPatientId) => {
    const patient = patientList.find(p => p.patientId.toString() === selectedPatientId);
    setSelectedPatient(patient);
    setAdditionalParamMap({ ...additionalParamMap, patient });
    setSelectedContainerFiles([]);
    setContainerFiles([]);
    if (patient) {
      fetchContainerFiles(patient.patientId);
    }
  };

  const fetchContainerFiles = async (patientId) => {
    setLoadingContainerFiles(true);
    setContainerFiles([]);
    setContainerFilesFetched(false);

    try {
      customLogger.log("zerobalance-dataprep -> UploadFiles -> fetchContainerFiles -> Request", JSON.stringify({ patientId }));

      const response = await fetch(`${API_BASE_URL}/get-documents?env=${encodeURIComponent(REACT_APP_ENV)}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('auth_token')
        },
        body: JSON.stringify({ "patientid":patientId, companyId: additionalParamMap.companyId, userName: additionalParamMap.userName })
      });

      if (!response.ok) {
        const errorResponse = await response.json();
        customLogger.log("zerobalance-dataprep -> UploadFiles -> fetchContainerFiles -> Error", errorResponse);
        if (response.status === 401) {
          logout();
          setTimeout(() => {
            navigate('/unauthorized', { state: { authFailed: true } });
          }, 0);
        } else {
          let errorMsg = errorResponse.Description || messages.errors.UNABLE_TO_FETCH_CONTAINER_FILES;
          throw new Error(errorMsg);
        }
      }

      const responseData = await response.json();
      customLogger.log("zerobalance-dataprep -> UploadFiles -> fetchContainerFiles -> Response", responseData);

      const mappedFiles = (Array.isArray(responseData) ? responseData : []).flatMap(container =>
        (container.files || []).map(f => ({
          id: f.full_path,
          name: f.file_name,
          folder_name: f.folder_name,
          full_path: f.full_path,
        }))
      );
      setContainerFiles(mappedFiles);
      setContainerFilesFetched(true);
    } catch (error) {
      customLogger.log("zerobalance-dataprep -> UploadFiles -> fetchContainerFiles -> Error", error);
      setError(error.message || messages.errors.UNABLE_TO_FETCH_CONTAINER_FILES);
      setContainerFiles([]);
    } finally {
      setLoadingContainerFiles(false);
    }
  };

  const handleContainerFileSelect = (file) => {
    if (getTotalSelectedCount() >= 20) {
      alert(messages.notifications.MAX_FILES_UPLOADED);
      return;
    }
    const isDuplicate = selectedContainerFiles.some(f => f.id === file.id);
    if (isDuplicate) {
      alert(messages.notifications.FILE_ALREADY_SELECTED(file.name));
      return;
    }
    setSelectedContainerFiles(prev => [...prev, file]);
  };

  const handleRemoveContainerFile = (index) => {
    setSelectedContainerFiles(prev => prev.filter((_, i) => i !== index));
  };

  const getTotalSelectedCount = () => {
    return selectedFiles.length + selectedContainerFiles.length;
  };

  // Function to read a file as ArrayBuffer
  const readFileAsArrayBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => resolve(e.target.result);

      reader.onerror = (e) => {
        //console.error("FileReader error:", e);
  
        // Most likely cause if file previously existed but now fails:
        const errorMessage = file.lastModified
          ? `The zip file "${file.name}" may have been modified or removed from your computer. Please re-upload it.`
          : `Failed to read the zip file "${file.name}".`;

        // alert(errorMessage);
        reject(new Error(errorMessage));
      };

      try {
        reader.readAsArrayBuffer(file);
      } catch (err) {
        //console.error("Exception while reading file:", err);
  
        const errorMessage = file.lastModified
          ? `The zip file "${file.name}" may have been modified or removed.`
          : `Unexpected error while reading "${file.name}".`;

        // alert(errorMessage);
        reject(new Error(errorMessage));
      }
    });
  };

  // Function to check if a file is a zip file
  const isZipFile = (file) => {
    return file.name.toLowerCase().endsWith('.zip') ||
      file.type === 'application/zip' ||
      file.type === 'application/x-zip-compressed';
  };

  // Function to extract files from a zip
  const extractZipFile = async (zipFile) => {
    try {
      const JSZip = (await import('jszip')).default;

      if (!(zipFile instanceof File)) {
        alert("Invalid or stale zip file:", zipFile);
        throw new Error("No valid zip file provided.");
      }

      // Read the zip file
      const zipData = await readFileAsArrayBuffer(zipFile);
      const zip = await JSZip.loadAsync(zipData);

      // Extract all files
      const extractedFiles = [];
      const zipEntries = Object.keys(zip.files);

      for (const entry of zipEntries) {
        const zipEntry = zip.files[entry];

        // Skip directories
        if (zipEntry.dir) continue;

        // Extract file data
        const fileData = await zipEntry.async('blob');

        // Create a File object from the blob
        const extractedFile = new File(
          [fileData],
          zipEntry.name.split('/').pop(),
          { type: fileData.type || 'application/octet-stream' }
        );

        extractedFiles.push(extractedFile);
      }

      return extractedFiles;
    } catch (error) {
      //console.error('Error extracting zip file:', error);
      if(error.message.includes('modified')) {
        throw new Error(error.message);  
      }
      throw new Error(`Failed to extract zip file: ${error.message}`);
    }
  };

  // Function to create a zip file from the selected files
  const createZipFile = async (files) => {
    try {
      // customLogger.log('Creating zip file from', files.length, 'files');

      // Import JSZip (already added as dependency in package.json)
      const JSZip = (await import('jszip')).default;

      // Check if we have only zip files or a mix of file types
      const zipFiles = files.filter(file => isZipFile(file));
      const nonZipFiles = files.filter(file => !isZipFile(file));

      // If we only have one zip file and no other files, return it as-is
      /*
      if (zipFiles.length === 1 && nonZipFiles.length === 0) {
        customLogger.log('Only one zip file uploaded, using it directly');
        return zipFiles[0];
      }
      */

      // If all files are zips and more than one, or if we have a mix of file types,
      // extract all zips and create a new consolidated zip
      const zip = new JSZip();
      const allFiles = [];

      // If we have both zip and non-zip files, or multiple zip files,
      // extract the zips and combine everything
      if (zipFiles.length > 0) {
        // customLogger.log(`Processing ${zipFiles.length} zip files and ${nonZipFiles.length} regular files`);

        let extractedfilesCount = 0;
        // Extract all zip files
        for (const zipFile of zipFiles) {
          // customLogger.log(`Extracting zip file: ${zipFile.name}`);
          const extractedFiles = await extractZipFile(zipFile);
          extractedfilesCount += extractedFiles.length;

          // Check if zip contains unsupported files
          for (const extractedFile of extractedFiles) {
            if (getFileType(extractedFile.name).toLowerCase() === 'unknown') {
              alert(zipFile.name + ' contains unsupported files.');
              setSelectedFiles([]);
              return;
            }
          }

          allFiles.push(...extractedFiles);
        }

        // Check if total files after unzipping is more than 20
        if ((extractedfilesCount + nonZipFiles.length) > 20) {
          alert(messages.errors.MAX_FILES);
          setSelectedFiles([]);
          return;
        }
      }

      // Add non-zip files directly
      allFiles.push(...nonZipFiles);

      // customLogger.log(`Total files after processing: ${allFiles.length}`);

      // Add each file to the new zip
      for (const file of allFiles) {
        // Read the file as ArrayBuffer
        const fileBuffer = await readFileAsArrayBuffer(file);

        // Add file to zip with its original name
        zip.file(file.name, fileBuffer);
      }

      // Generate zip file as blob
      return await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: { level: 6 } // Balance between size and speed
      });
    } catch (error) {
      //console.error('Error creating zip file:', error);
      if(error.message.includes('modified')) {
        throw new Error(error.message);  
      }
      throw new Error(messages.errors.FAILED_TO_CREATE_ZIP);
    }
  };

  // Check if mock services are enabled (will be false in Docker)
  const ENABLE_MOCK_SERVICES = process.env.REACT_APP_ENABLE_MOCK_SERVICES === 'true';
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://n8n.sentrihub.com/webhook';

  // Convert the blob of zip files to base64 string
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1]; // Remove `data:application/zip;base64,` part
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  /*
  // Convert the blob of zip files to binary (ArrayBuffer)
  const blobToBinary = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result); // This will be an ArrayBuffer
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(blob);
    });
  };
  */

  // Function to upload the zip file to the server
  const uploadZipFile = async (zipFile) => {
    try {
      if (!selectedPatient) {
        alert('Please select Client Association.');
        return;
      }

      let requestUrl;

      // Create a FormData object to send the file
      const formData = new FormData();
      // formData.append('file', zipFile, 'uploaded_files.zip');

      // Generate the current timestamp for request_id (format: YYYYMMDDHHMMSS)
      // const timestamp = new Date().toISOString().replace(/[-:T.]/g, '').slice(0, 14);
      // const req_id = uniqueId + "_" + timestamp;
      const req_id = uuidv4();

      // Format client_name as "ClientID_clientname"
      // Note: In a real implementation, you'd need to properly format this with an actual ClientID
      const clientId = Date.now().toString(); // Using timestamp as a placeholder for ClientID
      const formattedClientName = `${clientId}_${selectedPatient.patientId}`;

      // Add required metadata according to API spec
      const nameOfFile = 'uploaded_files_' + req_id + '.zip';
      setAdditionalInfo({
        "documentType": documentType,
        "filename": nameOfFile
      });
      formData.append('filename', nameOfFile);
      formData.append('userName', additionalParamMap.userName);

      if (process.env.REACT_APP_ENABLE_BINARY) {
        requestUrl = API_BASE_URL + "/upload-tax-files";
        // const binaryData = await blobToBinary(zipFile);
        formData.append('data', zipFile, 'uploaded_files.zip');
        // formData.append('data', zipFile);
      }
      else {
        requestUrl = API_BASE_URL + "/upload-files";
        const base64Zip = await blobToBase64(zipFile);
        formData.append('base64', base64Zip);
      }

      const mimeType = zipFile.type || 'application/zip';
      formData.append('type', mimeType);

      formData.append('client_name', formattedClientName);
      formData.append('pdfDocumentType', documentType);
      formData.append('smart_name_flag', generateSmartNames ? 'yes' : 'no');
      formData.append('request_id', req_id); 
      formData.append('patientId', selectedPatient.patientId); 
      formData.append('firstName', selectedPatient.firstName); 
      formData.append('lastName', selectedPatient.lastName); 

      if (selectedContainerFiles.length > 0) {
        const containerFileIds = selectedContainerFiles.map(f => f.id);
        formData.append('container_file_ids', JSON.stringify(containerFileIds));
      }


      // Use real API in Docker and when mock services are disabled
      if (!ENABLE_MOCK_SERVICES) {
        //customLogger.log('Using real API endpoint for file upload');
        
        // TODO: Uncomment and use this code when connecting to real API
        customLogger.log("zerobalance-dataprep -> UploadFiles -> uploadZipFile -> Request from React to n8n", formData)
        const response = await fetch(`${requestUrl}?env=${encodeURIComponent(REACT_APP_ENV)}`, {
          method: 'POST',
          body: formData,
          headers: {
            'Authorization': `${localStorage.getItem('auth_token')}`
          }
        });

        // Handle the response according to API specification
        if (response.ok) {
          const data = await response.json();
          customLogger.log("zerobalance-dataprep -> UploadFiles -> uploadZipFile -> Response from n8n to react", data)
          // API returns: [{ "success": "true -> unique_id": "98276c7e-4454-49a6-8ab9-f0fdec3f3f5e" }]
          if (data) {
            return {
              status: 200,
              json: () => Promise.resolve({ uniqueId: data.unique_id })
            };
          }
        } else {
          const errorResponse = await response.json();
           customLogger.log("zerobalance-dataprep -> UploadFiles -> uploadZipFile -> Error from n8n to react", errorResponse)
          if(response.status === 401) {
           // toast.error(messages.errors.SESSION_EXPIRED);
            logout();
            setTimeout(() => {
              navigate('/unauthorized', { state: { authFailed: true } });
            }, 0);
          } else {
            let errorMsg = errorResponse.Description || messages.errors.FAILED_TO_UPLOAD_FILES;

            setSelectedFiles([]);
            return {
              status: 500,
              json: () => Promise.resolve({ message: errorMsg })
            };
            //toast.error(errorMsg);
            // navigate('/');
            // throw new Error(errorMsg);
          }
        }
      } else {
        // Mock response for testing - only used in local development
        //customLogger.log('MOCK MODE: Using mock response for file upload');
       // customLogger.log('Zip file created successfully, size:', Math.round(zipFile.size / 1024), 'KB');
        return { 
          status: 200, 
          json: () => Promise.resolve({ uniqueId: 'test-123-456-789' }) 
        };
      }

    } catch (error) {
      //console.error('Error uploading zip file:', error);
      throw new Error(error.message || messages.errors.FAILED_TO_UPLOAD_FILES);
    }
  };

  // Function to check status of processing
  const checkStatus = async (id) => {
    try {
      if (!ENABLE_MOCK_SERVICES) {
        //customLogger.log('Using real API endpoint for status check');
        
        // TODO: Uncomment and use this code when connecting to real API

        // Get the token from localStorage
        const token = localStorage.getItem('auth_token');

        // Make POST request according to API specification
        customLogger.log("zerobalance-dataprep -> UploadFiles -> checkStatus -> Request from React to n8n", JSON.stringify({
            UniqueId: id
          }))
        const response = await fetch(`${API_BASE_URL}/response`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}` // Format as specified in the API
          },
          body: JSON.stringify({
            UniqueId: id
            // UniqueId: '20250625215958'
          })
        });

        if (!response.ok) {
          const errorResponse = await response.json();
          customLogger.log("zerobalance-dataprep -> UploadFiles -> checkStatus -> Error from n8n to react", errorResponse)
          if(response.status === 401) {
          //  toast.error(messages.errors.SESSION_EXPIRED);
            logout();
            setTimeout(() => {
              navigate('/unauthorized', { state: { authFailed: true } });
            }, 0);
          } else {
            return {
              success: false,
              status: ProcessFileStatus.COMPLETED,
              message: errorResponse[0].Description || messages.errors.FAILED_TO_UPLOAD_FILES
            };
          }
        }

        let responseData = await response.text();
        //customLogger.log("Raw response body:", responseData);
        if(responseData !== ""){
          responseData = JSON.parse(responseData);
          customLogger.log("zerobalance-dataprep -> UploadFiles -> checkStatus -> Response from n8n to react", responseData)
        }

        // API returns an array. If empty, it means processing is still ongoing
        if (!responseData || !Array.isArray(responseData) || responseData.length === 0) {
          return {
            status: ProcessFileStatus.PROCESSING,
          };
        }

        // If we have data in the response, processing is complete
        // The data format is: [{ "data": "[{\"json data received from python webservices\"}]" }]
        if (responseData) {
          try {
            // Parse the JSON string inside the data property
            const parsedData = responseData;
            return {
              status: ProcessFileStatus.COMPLETED,
              data: parsedData
            };
          } catch (parseError) {
            //console.error('Error parsing response data:', parseError);
            return {
              status: ProcessFileStatus.COMPLETED,
              data: responseData // Return as is if parsing fails
            };
          }
        }

        // If we reach here, we have a response but no data, treat as processing
        return {
          status: ProcessFileStatus.PROCESSING,
        };

        // Temporary implementation for status check when actual API is not connected
        // This return statement is required to prevent "Cannot read properties of undefined (reading 'status')" error

      } else {
        // Mock response for testing - only used in local development 
        //customLogger.log('MOCK MODE: Using mock response for status check');
        //customLogger.log('Checking status for ID:', id);
        
        // Simulate random success/failure for demonstration
        const isSuccess = Math.random() > 0.3; // 70% chance of success

        if (isSuccess) {
          return {
            status: ProcessFileStatus.COMPLETED,
            data: getSampleProcessedData()
          };
        } else {
          // Simulate empty array response from API, which means processing is ongoing
          return {
            status: ProcessFileStatus.PROCESSING,
          };
        }
      }
    } catch (error) {
     // console.error('Error checking status:', error);
      throw new Error(messages.errors.FAILED_TO_CHECK_PROCESSING_STATUS);
    }
  };

  // Sample processed data (moved from handleSubmit)
  const getSampleProcessedData = () => {
    if (selectedFiles.length > 0) {
      // Create data entries from the uploaded files
      return selectedFiles.map(file => ({
        fileName: file.name,
        calendarYear: '2025',
        formType: documentType || '1099-NEC',
        payorName: 'ABC Marketing LLC',
        payorAddress: '456 Business Rd',
        payorCity: 'Los Angeles',
        payorState: 'CA',
        payorCountry: 'USA'
      }));
    } else {
      // Use sample data
      return [
        {
          fileName: '1099-NEC_John_Smith.1099form.pdf',
          calendarYear: '2025',
          formType: '1099-NEC',
          payorName: 'ABC Marketing LLC',
          payorAddress: '456 Business Rd',
          payorCity: 'Los Angeles',
          payorState: 'CA',
          payorCountry: 'USA'
        },
        {
          fileName: '1099-MISC_Jane_Doe.1099form.pdf',
          calendarYear: '2025',
          formType: '1099-MISC',
          payorName: 'XYZ Consulting Inc',
          payorAddress: '789 Finance Ave',
          payorCity: 'New York',
          payorState: 'NY',
          payorCountry: 'USA'
        },
        {
          fileName: 'W2_Michael_Johnson.w2form.pdf',
          calendarYear: '2025',
          formType: 'W-2',
          payorName: 'Tech Solutions LLC',
          payorAddress: '123 Innovation St',
          payorCity: 'San Francisco',
          payorState: 'CA',
          payorCountry: 'USA'
        },
        {
          fileName: 'K1_Sarah_Williams.k1form.pdf',
          calendarYear: '2025',
          formType: 'Schedule K-1',
          payorName: 'Global Partners LP',
          payorAddress: '567 Investment Blvd',
          payorCity: 'Chicago',
          payorState: 'IL',
          payorCountry: 'USA'
        }
      ];
    }
  };

  // Function to poll server for status
  const pollForStatus = async (id, count) => {
    try {
      // Check if we've been polling too long (10 minutes = 600000 ms)
      const currentTime = Date.now();
      const elapsedTime = currentTime - startTimeRef.current;

      // Max 26 minutes for a single request
      if (elapsedTime > 1560000) {
        setIsLoading(false);
        setError(messages.errors.SERVER_BUSY);
        setSelectedFiles([]);
        return;
      }

      const result = await checkStatus(id);

      if (result.status === ProcessFileStatus.COMPLETED) {
        if (result && result.success !== undefined && result.success === false) {
          throw new Error(`${result.message}`);
        }

        // Processing completed, move to preview
        setIsLoading(false);

        const processedData = result.data;

        // Pass data to the parent component if needed
        if (onPrepareData) {
          onPrepareData(processedData);
        }

        // Navigate to preview page
        navigate('/preview', { state: { processedData } });
      } else {
        if (count <= 780) {
          // Still processing, poll again in 2 seconds
          pollTimerRef.current = setTimeout(() => pollForStatus(id, count + 1), 2000);
        } else {
          toast.error(messages.errors.LOTS_OF_DATA_PREP);
          navigate('/');
        }
      }
    } catch (error) {
      setIsLoading(false);
      setSelectedFiles([]);
      setSelectedContainerFiles([]);
      setError(error.message || messages.errors.ERROR_OCCURRED);
      navigate('/upload', { state: { error: error.message } });
    }
  };


  const getFileStatus = async (count = 0) => {
    try {
      
      customLogger.log("zerobalance-dataprep -> UploadFiles -> getFileStatus -> Request from React to n8n", JSON.stringify({ 'userName': additionalParamMap.userName }))
      const res = await fetch(`${API_BASE_URL}/response?env=${encodeURIComponent(REACT_APP_ENV)}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${localStorage.getItem('auth_token')}`
        },
        body: JSON.stringify({ userName: additionalParamMap.userName })
      });
      
      if (!res.ok) {
         setSpinner(false)

        const errorResponse = await res.json();
        customLogger.log("zerobalance-dataprep -> UploadFiles -> getFileStatus -> Error response from n8n to react", errorResponse[0]?.Description)

        let errorMsg = `Previous job status: ${errorResponse[0]?.Description || "Unknown error"}`;

        if (res.status === 401) {
          errorMsg = messages.errors.SESSION_EXPIRED;
          logout();
          setTimeout(() => {
            navigate('/unauthorized', { state: { authFailed: true } });
          }, 0);
        }
        // toast.error(errorMsg,  {
        // autoClose: 8000,
        // });
        setIsPending(false)
        setError(errorMsg)
        return {
          success: false,
          message:
          errorResponse?.Description ||
          errorResponse?.[0]?.Description ||
          `Fail to process your previous file`,
        };

      }

      const result = await res.json();
      customLogger.log("zerobalance-dataprep -> UploadFiles -> getFileStatus -> Response from n8n to react", result)
      // const patient = patientList.find(p => p.patientId.toString() === result.patientId);
      // setAdditionalParamMap({ ...additionalParamMap, patient });
      // console.log("****", additionalParamMap,result.patientId, patient)
      setSpinner(false)
      if (result.status === "FAILED" || (result.status === "SUCCESS" && result.data?.length)) {
        setFileStatusData({
          status: result.status,
          data: result.data,
          firstName: result.first_name,
          lastName:result.last_name,
          patientId: result.patient_id,
          documentType: result.template_type,
          fileName: result.file_name          
        })

        navigate('/preview');
      } else if (result.status === "PENDING") {
        setIsPending(true)
         if (count <= 780) {
        setTimeout(() => getFileStatus(count + 1), 2000);
         }
      }
    } catch (error) {
      const errorMsg = error?.Description || error?.message || "Unexpected error";
      toast.error(`Previous job status: ${errorMsg}`, {
        autoClose: 8000,
      });

      customLogger.log("zerobalance-dataprep -> UploadFiles -> getFileStatus -> Error from n8n to react", error)
    }
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      setError(null);
      startTimeRef.current = Date.now();

      if (selectedFiles.length > 0) {
        const zipFile = await createZipFile(selectedFiles);

        if (zipFile) {
          const response = await uploadZipFile(zipFile);

          if (response?.status === 200) {
            const data = await response.json();
            const id = data.uniqueId;

            pollForStatus(id, 1);
          } else if (response?.status === 500) {
            const errorData = await response.json();
            setIsLoading(false);
            setError(errorData.message || messages.errors.SERVER_ERROR_OCCURRED);
            navigate('/upload', { state: { error: errorData.message } });
          } else {
            setIsLoading(false);
            setError(messages.errors.UNEXPECTED_SERVER_RESPONSE);
            navigate('/upload', { state: { error: messages.errors.UNEXPECTED_SERVER_RESPONSE } });
          }
        } else {
          navigate('/');
        }
      } else if (selectedContainerFiles.length > 0) {
        const response = await uploadContainerOnlyFiles();

        if (response?.status === 200) {
          const data = await response.json();
          const id = data.uniqueId;
          pollForStatus(id, 1);
        } else if (response?.status === 500) {
          const errorData = await response.json();
          setIsLoading(false);
          setError(errorData.message || messages.errors.SERVER_ERROR_OCCURRED);
          navigate('/upload', { state: { error: errorData.message } });
        } else {
          setIsLoading(false);
          setError(messages.errors.UNEXPECTED_SERVER_RESPONSE);
          navigate('/upload', { state: { error: messages.errors.UNEXPECTED_SERVER_RESPONSE } });
        }
      }
    } catch (error) {
      setIsLoading(false);
      setError(error.message || messages.errors.ERROR_OCCURRED);
      setSelectedFiles([]);
      setSelectedContainerFiles([]);
      navigate('/upload', { state: { error: error.message } });
    }
  };

  const uploadContainerOnlyFiles = async () => {
    try {
      if (!selectedPatient) {
        alert('Please select Client Association.');
        return;
      }

      const req_id = uuidv4();
      const clientId = Date.now().toString();
      const formattedClientName = `${clientId}_${selectedPatient.patientId}`;

      const nameOfFile = 'upload_files_' + req_id + '.zip';
      setAdditionalInfo({
        "documentType": documentType,
        "filename": nameOfFile
      });

      const formData = new FormData();
      formData.append('filename', nameOfFile);
      formData.append('userName', additionalParamMap.userName);

      const requestUrl = API_BASE_URL + "/upload-tax-files";

      formData.append('type', 'application/zip');
      formData.append('client_name', formattedClientName);
      formData.append('pdfDocumentType', documentType);
      formData.append('smart_name_flag', generateSmartNames ? 'yes' : 'no');
      formData.append('request_id', req_id);
      formData.append('patientId', selectedPatient.patientId);
      formData.append('firstName', selectedPatient.firstName);
      formData.append('lastName', selectedPatient.lastName);
      const containerFileIds = selectedContainerFiles.map(f => f.id);
      if (containerFileIds.length > 0) {
        formData.append('container_file_ids', JSON.stringify(containerFileIds));
      }

      if (!ENABLE_MOCK_SERVICES) {
        customLogger.log("zerobalance-dataprep -> UploadFiles -> uploadContainerOnlyFiles -> Request", formData);
        const response = await fetch(`${requestUrl}?env=${encodeURIComponent(REACT_APP_ENV)}`, {
          method: 'POST',
          body: formData,
          headers: {
            'Authorization': `${localStorage.getItem('auth_token')}`
          }
        });

        if (response.ok) {
          const data = await response.json();
          customLogger.log("zerobalance-dataprep -> UploadFiles -> uploadContainerOnlyFiles -> Response", data);
          if (data) {
            return {
              status: 200,
              json: () => Promise.resolve({ uniqueId: data.unique_id })
            };
          }
        } else {
          const errorResponse = await response.json();
          customLogger.log("zerobalance-dataprep -> UploadFiles -> uploadContainerOnlyFiles -> Error", errorResponse);
          if (response.status === 401) {
            logout();
            setTimeout(() => {
              navigate('/unauthorized', { state: { authFailed: true } });
            }, 0);
          } else {
            let errorMsg = errorResponse.Description || messages.errors.FAILED_TO_UPLOAD_FILES;
            setSelectedFiles([]);
            setSelectedContainerFiles([]);
            return {
              status: 500,
              json: () => Promise.resolve({ message: errorMsg })
            };
          }
        }
      } else {
        return {
          status: 200,
          json: () => Promise.resolve({ uniqueId: 'test-container-123-456-789' })
        };
      }
    } catch (error) {
      throw new Error(error.message || messages.errors.FAILED_TO_UPLOAD_FILES);
    }
  };

  const getDocLabelByDocId = (id) => {
    const match = Object.values(PdfDocumentTypeEnum).find(val => val.startsWith(id));
    return match ? match.split('|')[1] : '';
  };

  const handlePDF_DocumentTypeSelect = (eventKey) => {
    setDocumentType(eventKey); // Store "1099_analysis"
  };

  // Get file type for display
  const getFileType = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    if (['pdf'].includes(extension)) {
      return 'PDF';
    } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tif', 'tiff', 'webp', 'heic', 'heif'].includes(extension)) {
      return 'Image';
    } else if (['zip'].includes(extension)) {
      return 'Zip';
    } else if (['csv'].includes(extension)) {
    return 'CSV';
    } else if (['xls', 'xlsx'].includes(extension)) {
    return 'Excel';
    } else {
      return 'Unknown';
    }
  };

  // if (spinner) {
  //   return <div>Loading...</div>;
  // }


  // Render loading screen
  if (isLoading || isPending) {
    return (
      <div className="container loading-container">
        <h1>Data Prep: Tax and Financial PDF</h1>
        <p className="subtitle">Upload financial PDF data for analysis prep downloadable excel file.</p>

        <div className="loading-spinner-container">
          <div className="loading-spinner"></div>

          <p className="loading-message" style={{ marginBottom: isLoading ? "16px" : "2px" }}>{isPending ? "Data Prep Agent is still working on your previous job." : "Data Prep Agent is preparing your file... Please Wait, or you can exit and come back later."}</p>
          <p className="loading-message" style={{ marginBottom: isLoading ? "16px" : "2px" }}>{isPending ? "Please wait or come back later to view your results and submit new files." : (
            <>
              The Data Prep process takes approximately <b>40 seconds</b> per document.
            </>
          )}</p>
        </div>
      </div>
    );
  }

  const DOCUMENT_TYPE_TEXT_MAP = {
    '1099_analysis': 'Supported forms: 1099-INT, 1099-DIV, 1099-NEC, 1099-MISC, 1099-B, 1099-R, 1099-G, 1099-K',
    'auditor_assistant': 'Supported forms: 1120-S'
  };

  const handleDataChange = (newData) => {

  };

  if (!spinner || location.state?.from === "preview") {
    return (
      <div className="container">
        <h1>Data Prep: Tax and Financial PDF</h1>
        <p className="subtitle">Upload financial PDF data for analysis prep downloadable excel file.</p>

        {error && (
          <div
            className="error-message mx-auto text-center"
            style={{
              width: isMobile ? '100%' : '40%',
            }}
          >
            <p className="mb-0">{error}</p>
          </div>
        )}

        <Row className='justify-content-center'>
          <Col md={3}>
            <Dropdown onSelect={handlePatientSelect} className="mb-2">
              <Dropdown.Toggle
                variant="light"
                id="dropdown-client-association"
                className="w-100 d-flex justify-content-between align-items-center"
              >
                <span style={{
                  maxWidth: '300px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>
                  {selectedPatient ? `${selectedPatient.firstName} ${selectedPatient.lastName}` : "Select Client"}
                </span>

              </Dropdown.Toggle>
              <Dropdown.Menu className='dropdown-auto-width'>
                <div className="px-3 py-2">
                  <FormControl
                    autoFocus
                    placeholder="Search client..."
                    onChange={(e) => setSearchTerm(e.target.value)}
                    value={searchTerm}
                  />
                </div>
                <Dropdown.Divider />

                <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {filteredPatients?.length === 0 ? (
                    <Dropdown.Item disabled>{loadingPatients ? messages.notifications.LOADING_CLIENTS : messages.notifications.NO_CLIENTS_FOUND}</Dropdown.Item>
                  ) : (
                    filteredPatients.map((patient) => (
                      <Dropdown.Item
                        key={patient.patientId}
                        eventKey={patient?.patientId?.toString()}
                        active={patient.patientId === selectedPatient?.patientId}
                        as="div"
                        style={{
                          width: '100%',
                          display: 'block',
                          whiteSpace: 'nowrap',
                          overflowX: 'hidden',
                          cursor: 'pointer'
                        }}
                        onDragStart={(e) => e.preventDefault()}
                      >
                        {patient.firstName} {patient.lastName}
                      </Dropdown.Item>
                    ))
                  )}
                </div>
              </Dropdown.Menu>
            </Dropdown>

          </Col>

          <Col md={3}>
            <Dropdown onSelect={handlePDF_DocumentTypeSelect} className="mb-2">
              <Dropdown.Toggle
                variant="light"
                id="dropdown-document-type"
                className="w-100 d-flex justify-content-between align-items-center"
              >
                <span>{getDocLabelByDocId(documentType)}</span> {/* Show label */}
              </Dropdown.Toggle>
              <Dropdown.Menu className='w-100'>
                <Dropdown.Item disabled>PDF Document Type</Dropdown.Item>
                {Object.entries(PdfDocumentTypeEnum).map(([key, value]) => {
                  const [id, label] = value.split('|');
                  return (
                    <Dropdown.Item
                      key={id}
                      eventKey={id}
                      active={id === documentType}
                      as="div"
                       style={{                         
                          cursor: 'pointer'
                        }}
                      onDragStart={(e) => e.preventDefault()}
                    >
                      {label}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>

        <div className="upload-section">
          <div className="radio-group">
            <label>Generate Smart File Names?</label>
            <div className="radio-option">
              <input
                type="radio"
                id="smart-names-yes"
                name="smart-names"
                className="radio-button"
                checked={generateSmartNames}
                onChange={() => setGenerateSmartNames(true)}
              />
              <label htmlFor="smart-names-yes">Yes</label>
            </div>
            <div className="radio-option">
              <input
                type="radio"
                id="smart-names-no"
                name="smart-names"
                className="radio-button"
                checked={!generateSmartNames}
                onChange={() => setGenerateSmartNames(false)}
              />
              <label htmlFor="smart-names-no">No</label>
            </div>
          </div>
          {isPending && (
            <div
              className="status-message mx-auto text-center"
              style={{
                width: isMobile ? '100%' : '50%',
              }}
            >
              <p className="mb-0">Your previous job is still running. Please wait or come back later.</p>
            </div>
          )}

          {DOCUMENT_TYPE_TEXT_MAP[documentType] && (
            <div>
              <p>
                <i>{DOCUMENT_TYPE_TEXT_MAP[documentType]}</i>
              </p>
            </div>
          )}

          <Row className="upload-title-row">
            <Col className="upload-title-left">
              <h4 className="upload-split-title">Upload Files</h4>
            </Col>
            <Col xs="auto" className="upload-or-col">
              <span className="upload-or-text upload-split-title">OR</span>
            </Col>
            <Col className="upload-title-right">
              <h4 className="upload-split-title bold">Select a file from storage</h4>
            </Col>
          </Row>
          <Row className="upload-split-layout">
            <Col xs={12} md={6} className="upload-split-left">
              <FileUpload onFileSelect={handleFileSelect} selectedFiles={selectedFiles} selectedContainerFiles={selectedContainerFiles} />
            </Col>
            <div className="upload-mobile-or"><span>OR</span></div>
            <Col xs={12} md={6} className="upload-split-right">
              <h4 className="upload-split-title bold d-md-none">Select a file from storage</h4>
              <SelectFileDropdown
                containerFiles={containerFiles}
                onFileSelect={handleContainerFileSelect}
                selectedContainerFiles={selectedContainerFiles}
                disabled={!selectedPatient}
                loadingContainerFiles={loadingContainerFiles}
              />


            </Col>
          </Row>

          <div style={{ textAlign: "center", marginTop: "8px" }}>
            <p><i><small>Supported formats: PDF, ZIP, PNG, JPEG, GIF, BMP, TIFF, WEBP, HEIC, HEIF, CSV, XLSX</small></i></p>
          </div>

          {(selectedFiles.length > 0 || selectedContainerFiles.length > 0) && (
            isMobile ? (
              <div className="selected-files mt-3">
                <h3>Selected Files ({getTotalSelectedCount()})</h3>
                <ul className="file-list">
                  {selectedFiles.map((file, index) => (
                    <li key={`upload-${index}`} className="file-item mb-3">
                      <Card className="h-100 position-relative bg-transparent border-0 shadow-none w-100">
                        <Card.Body className="position-relative">
                          <button
                            title="Remove file"
                            onClick={() => handleRemoveFile(index)}
                            style={{
                              position: 'absolute',
                              top: '26px',
                              right: '8px',
                              background: 'none',
                              border: 'none',
                              padding: 0,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '24px',
                              height: '24px',
                            }}
                          >
                            <XCircleFill size={24} color="#ff6b6b" />
                          </button>

                          <div className="d-flex flex-column flex-md-row align-items-start">
                            <div className="file-type me-2">{getFileType(file.name)}</div>
                            <span className="file-name me-2" title={file.name}>{file.name}</span>
                            <span className="file-size">({((file.size || 0) / 1024).toFixed(2)} KB)</span>
                          </div>
                        </Card.Body>
                      </Card>
                    </li>
                  ))}
                  {selectedContainerFiles.map((file, index) => (
                    <li key={`container-${index}`} className="file-item mb-3">
                      <Card className="h-100 position-relative bg-transparent border-0 shadow-none w-100">
                        <Card.Body className="position-relative">
                          <button
                            title="Remove file"
                            onClick={() => handleRemoveContainerFile(index)}
                            style={{
                              position: 'absolute',
                              top: '26px',
                              right: '8px',
                              background: 'none',
                              border: 'none',
                              padding: 0,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '24px',
                              height: '24px',
                            }}
                          >
                            <XCircleFill size={24} color="#ff6b6b" />
                          </button>

                          <div className="d-flex flex-column flex-md-row align-items-start">
                            <div className="file-type container-file-badge me-2">{getFileType(file.name)}</div>
                            <span className="file-name me-2" title={file.full_path?.replace(/^\//, '')}>{file.full_path?.replace(/^\//, '')}</span>
                            <span className="file-size">({((file.size || 0) / 1024).toFixed(2)} KB)</span>
                          </div>
                        </Card.Body>
                      </Card>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div className="selected-files">
                <h3>Selected Files ({getTotalSelectedCount()})</h3>
                <ul className="file-list">
                  {selectedFiles.map((file, index) => (
                    <li key={`upload-${index}`} className="file-item">
                      <span className="file-type">{getFileType(file.name)}</span>
                      <span className="file-name" title={file.name}>{file.name}</span>
                      <span className="file-size">({((file.size || 0) / 1024).toFixed(2)} KB)</span>
                      <span>
                        <button
                          title="Remove file"
                          onClick={() => handleRemoveFile(index)}
                          style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '24px',
                            height: '24px',
                          }}
                        >
                          <XCircleFill size={24} color="#ff6b6b" />
                        </button>
                      </span>
                    </li>
                  ))}
                  {selectedContainerFiles.map((file, index) => (
                    <li key={`container-${index}`} className="file-item">
                      <span className="file-type container-file-badge">{getFileType(file.name)}</span>
                      <span className="file-name" title={file.name}>{file.full_path?.replace(/^\//, '')}</span>
                      <span className="file-size">({((file.size || 0) / 1024).toFixed(2)} KB)</span>
                      <span>
                        <button
                          title="Remove file"
                          onClick={() => handleRemoveContainerFile(index)}
                          style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '24px',
                            height: '24px',
                          }}
                        >
                          <XCircleFill size={24} color="#ff6b6b" />
                        </button>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )
          )}

          <button
            onClick={handleSubmit}
            disabled={getTotalSelectedCount() === 0 || !selectedPatient}
            className='app-primary-btn'
            style={{ marginTop: '10px', marginBottom: '20px' }}
          >
            <b>{getTotalSelectedCount() === 0 ? "Select Files to Prepare" : `Prepare ${getTotalSelectedCount()} File${getTotalSelectedCount() === 1 ? '' : 's'}`}</b>
          </button>
        </div>

        {show && (
          <div
            className="modal show fade d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Your previous job result is here</h5>
                  <button type="button" className="btn-close" onClick={() => setShow(false)}></button>
                </div>


                <div
                  className="modal-body"
                  style={{
                    maxHeight: '400px',
                    overflowY: 'auto',
                    padding: '0.5rem 1rem'
                  }}
                >
                  {loading ? (
                    <p>Loading...</p>
                  ) : (

                    <div className="table-responsive">
                      {/* <table className="table table-bordered table-hover table-sm mb-0">
                      <thead className="table-light ">
                        <tr>
                          {headers.map((key, i) => (
                            <th className='text-nowrap text-truncate overflow-hidden' style={{                              
                              maxWidth: '250px'            
                            }} key={i}>{key}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {apiData.map((item, rowIndex) => (
                          <tr key={rowIndex}>
                            {headers.map((key, colIndex) => (
                              <td key={colIndex}>{item[key]}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table> */}
                      <DataTable data={apiData} onDataChange={handleDataChange} />

                    </div>

                  )}
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setShow(false)}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  };


};

export default UploadFiles;
